import getEnvironment from "../helpers/getEnvironment";
import { BCAValuationDTO } from "../vehicleDetails/vehicle-details-dto.type";

const getBCAValuation = async (
  bcaValuationUrl: string,
  vrm: string,
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const bcaValuationResponse = await fetch(bcaValuationUrl, {
    method: "GET",
    headers,
  });

  if (bcaValuationResponse.status === 200) {
    const bcaValuationAPIResult: {
      [id: string]: BCAValuationDTO;
    } = await bcaValuationResponse.json();

    const bcaValuationPrice =
      Object.keys(bcaValuationAPIResult).length !== 0
        ? bcaValuationAPIResult[vrm.replace(" ", "")]?.valuation?.toString()
        : null;

    return bcaValuationPrice;
  }
  return null;
};

export default getBCAValuation;
